var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.route)?_c('router-link',{attrs:{"to":{ name: _vm.item.route }}},[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.item.href,"target":"_blank","rel":"noopener"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }